import React from 'react';
import PartnersLaboratories from '../PartnersLaboratories/PartnersLaboratories';
import PartnersPrestataires from '../PartnersPrestataires/PartnersPrestataires';
import './Partners.css';

const Partners = () => {
  return (
    <div className="Partners">
      <div className="Partners__container">
        <div className="Partners__title">Nos partenaires</div>
        <div className="Partners__text">
          Plus de 60 partenariats directs laboratoires et prestataires de
          services.
        </div>
        <PartnersLaboratories />
        <PartnersPrestataires />
      </div>
    </div>
  );
};

export default Partners;
